import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import InstantSearch from 'vue-instantsearch';
import App from './App.vue';

Vue.use(VueCompositionAPI);
Vue.use(InstantSearch);

const autocompleteSearches = document.querySelectorAll('.vue-algolia-autocomplete');
autocompleteSearches.forEach((autocomplete) => {
    new Vue({
        render: (h) => h(App)
    }).$mount(autocomplete);
});
